import {ChatRepository} from "@/repositories/chat.repository.ts";
import {uuid} from "@/interfaces";
import {ChatRoom} from "@/models/chat.model.ts";
import {toChatRoom} from "@/repositories/chat-records.ts";
import {store} from "@/lib/store.ts";
import {upsertRoom} from "@/app/user/messages/messages.slice.ts";

export const AppointmentChatService = {
    async addMember(roomId: uuid, person: uuid): Promise<boolean> {
        const {added, room} = await ChatRepository.addMember(roomId, person, store.getState().organization.activeOrgId);
        store.dispatch(upsertRoom(toChatRoom(room)));
        return added;
    },

    async getAppointmentGroupChat(appointmentId: uuid): Promise<ChatRoom | null> {
        try {
            const room = await ChatRepository.roomOfAppointment(appointmentId);
            return room === null ? null : toChatRoom(room);
        } catch (error) {
            console.error(`Failed to get appointment group chat for ${appointmentId}:`, error);
            return null;
        }
    }
};
